<template>
    <div class="about-mob" v-if="loaded && ready">
      <transition name="fade">
      <div class="main-about">
        <div class="about-mob-sec" v-for="i in 5" :id="'about-mob-sec' + i" :class="[{'vis' :  offSet.last >= (i - 1)}, {'about-mob-hero' : i == 1} , {'about-mob-hero about-mob-last' : i == 5} ]">

          <div class="about-mob-sec-box">
            <h1 v-html="aboutData.item[(i -1)].title[lang].name"></h1>
            <p v-html="aboutData.item[(i -1)].text[lang].name"></p>
          </div>

          <img :src="aboutData.item[(i -1)].image" :alt="aboutData.item[(i -1)].title[lang].name">
        </div>

        <div class="about-mob-sec" :class="{'vis' :  offSet.last >= 5}">

          <div class="about-mob-sec-box">
            <h1 v-html="aboutData.ofer.title[lang].name"></h1>
            <p v-html="aboutData.ofer.text[lang].name"></p>

            <div class="ofer-items">
              <div class="ofer-item" :class="'ofer-item' + index" v-for="(item, index) in aboutData.ofer.item" v-html="item.name[lang].name"></div>
            </div>
          </div>


        </div>

        <div class="about-mob-sec about-mob-sec-7" :class="{'vis' :  offSet.last >= 6}" >

          <div class="about-mob-sec-box">
            <h1 v-html="aboutData.item[5].title[lang].name"></h1>
            <p v-html="aboutData.item[5].text[lang].name"></p>
          </div>

          <img :src="aboutData.item[5].image" :alt="aboutData.item[5].title[lang].name">
        </div>

        <div class="about-mob-sec" :class="{'vis' :  offSet.last >= 7}">

          <div class="about-mob-sec-box">
            <h1 v-if="lang == 0"> Prémios  principais   </h1>
            <h1 v-if="lang == 1"> Main  awards   </h1>
            <div  v-for="(item, index) in aboutData.rec" class="prize-item" >
              <strong>{{item.year}}</strong>
              <div class="prize-item-row">
                <div class="prize-item-col1">{{item.ent}}</div>
                <div class="prize-item-col2">{{item.des[lang].name}}</div>
              </div>

            </div>
          </div>


        </div>










        <div  class="about-mob-sec-footer" :class="{'vis' :  offSet.last >= 8}">
          <div v-if="offSet.last >= 8">
            <footer-nossa :lang="lang" :isMobile="true" :big="'big'"  ></footer-nossa>
          </div>

        </div>

        <!--

        <div class="sec-about-img" >
          <img id="imgmove" :src="simpleBlock[0].img" alt="">
        </div>


        <div class="sec-about sec-about1" :class="{'vis' :  offSet.last >= 0}">
          <div class="main-headline">
            <h1 class="head-line-orange">{{simpleBlock[0].headline.orange[lang].name}}</h1>
            <h1 class="head-line-white">{{simpleBlock[0].headline.white[lang].name}}</h1>

          </div>

        </div>


        <div class="sec-about sec-about2" :class="{'vis' :  offSet.last >= 1}">
          <div class="text-about-sec" v-html="simpleBlock[0].text[lang].name">   </div>
        </div>


        <div class="sec-about sec-about3" :class="{'vis' :  offSet.last >= 2}">
          <div class="main-headline">
            <div class="main-headline-item">
              <h1 class="head-line-white">Approach</h1>
              <h1 class="head-line-orange">&</h1>
            </div>
            <div class="main-headline-item">
              <h1 class="head-line-white">Methodology</h1>
            </div>
          </div>
        </div>

        <div class="sec-about sec-about4" :class="{'vis' :  offSet.last >= 3}">
          <p class="text-about-sec" v-html="simpleBlock[1].text[lang].name">   </p>
        </div>


        <div class="sec-about sec-about5" :class="{'vis' :  offSet.last >= 4}">
          <div class="main-headline">
            <div class="main-headline-item">
              <h1 class="head-line-white">Fully integrated.</h1>
            </div>
            <div class="main-headline-item">
              <h1 class="head-line-white">360</h1><span class="head-line-orange">º</span>   <h1 class="head-line-white">creative</h1>
            </div>
          </div>
        </div>

        <div class="sec-about sec-about6" :class="{'vis' :  offSet.last >= 5}">
          <ul>
            <li   v-for="(item, index) in listBlock[0].list"  >  {{item.listitem[lang].name}} </li>
          </ul>
          <p class="text-about-sec" v-html="listBlock[0].text[lang].name">   </p>
        </div>

        <div class="sec-about process-block " v-for="(item, index) in processBlock" :class="['sec-about' + (7 + index), {'vis' :  offSet.last >= (6 + index)}]">

          <img :src="processBlock[index].image"  :alt="processBlock[index].title[lang].name"  >

          <div class="process-block-content">
            <h5 class="process-block-label" v-html="item.label[lang].name"></h5>
            <h1 class="process-block-title" v-html="item.title[lang].name"></h1>
            <p class="process-block-text" v-html="item.text[lang].name"></p>
          </div>

        </div>

        <div  class="sec-about sec-about10" >
          <div v-if="offSet.last >= 8">
            <footer-nossa :lang="lang" :isMobile="true" :big="'big'"  ></footer-nossa>
          </div>

        </div>

-->

      </div>




      </transition>











    </div>
</template>

<script>


import {NavEvents} from "../dataModules/NavEvents";
    import {TweenMax} from "gsap/TweenMax";
    import {EVENTBUS, WP} from '../main';

    import FooterNossa from "./FooterNossa";




    export default {

        name: 'about-mob',
      components: {FooterNossa},
      props: ['actRoute', 'isMobile', 'lang'],
        data() {
            return {

              aboutData: [],
              simpleBlock: [],
              listBlock: [],
              processBlock: [],
              loaded: false,
              ready: false,


              incPagePos: 0,
              stopInc: false,


              footerVisited : '',
              main: {},
              stopSwipe: false,
              doneScreen: '',

              offSet: {
                vis: [],
                tops: [],
                last: -1
              },


            }
        },

      head: {
        title: function () {
          const _this = this;
          return {
            inner: 'NOSSA™',   separator: '|',   complement: 'Agência'
          }
        },


      },

      created() {

          const _this = this;

        WP('agency', function (response){

          _this.aboutData = response[0];
          _this.loaded = true;



          /*
          _this.simpleBlock = _this.aboutData['simple-block'];
          _this.listBlock = _this.aboutData['list-block'];
          _this.processBlock = _this.aboutData['process-block'];
          console.log(_this.aboutData)


           */

          _this.init();


        });

      },
      mounted() {
        this.ready = true;
        this.init();
        //EVENTBUS.$on('AAA', AAA);
        //EVENTBUS.$emit('AAA', 0);
        $(window).scrollTop(0);
        $('body, html').scrollTop(0);
      },

      destroyed() {

      },

      methods: {

        init() {

          const _this = this;

          if(_this.loaded && _this.ready){







            setTimeout(function(){

              _this.initScroll();





            },500);

          }



        },


        initScroll(){
          const _this = this;
          console.log(_this.offSet)
          setTimeout(() =>{

            $('.about-mob-sec, .about-mob-sec-footer').each(function(i){
              _this.offSet.tops.push($(this).offset().top);

            });

            $( window ).scroll(function(e) {

              _this.scrollEvt()
            });

            $( window ).resize(function() {
              _this.reseizeMe();
            });

            _this.reseizeMe();
            _this.scrollEvt();

          }, 100)
        },

        reseizeMe() {
          this.scrollEvt()
        },

        scrollEvt() {

          const _this = this;

          _this.offSet.act =  $( window ).scrollTop() +  $( window ).height();

          //EVENTBUS.$emit('log', _this.offSet.tops[5])

          //_this.moveImg()

          $('.about-mob-sec, .about-mob-sec-footer').each(function(i){

            if(_this.offSet.act > (_this.offSet.tops[i]  + 200) &&  !_this.offSet.vis[i]) {


              _this.offSet.last = i;
              _this.offSet.vis[i] = true;
            }

          });

        },


        moveImg(){

          let ref = ((window.innerWidth * 2)* $( window ).scrollTop()) / (this.offSet.tops[5] );
          let ref2 = 0 - ref;

          TweenMax.to('#imgmove' , 0.2, { force3D: true, x: ref2, ease:"circ.out"} );
          EVENTBUS.$emit('log', ref2)


        }









      },
    };

</script>


// WEBPACK FOOTER //
// src/components/AboutMob.vue